import Nullstack from 'nullstack';
export default function IconNotes({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-notes",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "5",
    y: "3",
    width: "14",
    height: "18",
    rx: "2"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "7",
    x2: "15",
    y2: "7"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "11",
    x2: "15",
    y2: "11"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "15",
    x2: "13",
    y2: "15"
  }), " ");
}